import { GlobalError } from "./GlobalError"

type Data = {
  data: {
    errorName: string
  }
  cause: Data
}

export class BlockchainError extends GlobalError {
  options?: ErrorOptions
  rawError: Error
  keyReason: string
  constructor(
    keyReason: string,
    message: string,
    rawError: Error,
    options?: ErrorOptions,
  ) {
    super("blockchain-error", message)
    this.keyReason = keyReason
    this.rawError = rawError

    const cause: Data = rawError.cause as unknown as Data
    if (cause?.data?.errorName) {
      this.keyReason = cause.data?.errorName
    } else if (cause?.cause?.data?.errorName) {
      this.keyReason = cause?.cause?.data?.errorName
    }

    this.options = options || {}
  }
}
